import {RecognizedPhrase} from "./RecognizedPhrase";

export default class PhrasesRegistry {

    private phrases: Map<string, RecognizedPhrase> = new Map<string, RecognizedPhrase>();

    constructor() {

    }

    public upsertPhrase(phraseId: string, phrase: string, isStable: boolean) : boolean {
        let isNewPhrase = false;
        let recognizedPhrase = this.phrases.get(phraseId);
        if (!recognizedPhrase) {
            recognizedPhrase = new RecognizedPhrase();
            this.phrases.set(phraseId, recognizedPhrase);
            isNewPhrase = true;
        }
        if (isStable) {
            recognizedPhrase.stablePhrase = phrase;
        } else {
            recognizedPhrase.unstablePhraseFragments.push(phrase);
        }
        return isNewPhrase;
    }

    public getPhrase(phraseId: string) : RecognizedPhrase | undefined {
        return this.phrases.get(phraseId);
    }

}
